/**
 * @biomax/plugin-pathogen-genomics — pathogen genomic reference layer.
 *
 * v0.3 ships Tier 1 + Tier 2:
 *   - Tier 1: accession IDs (RefSeq / GenBank / UniProt) for every
 *     catalogued pathogen
 *   - Tier 2: bundled reference FASTA + metadata for the 8 records
 *     with stable single-segment RefSeq references (SARS-CoV-2
 *     wild-type, measles, RSV, dengue DENV-1, Ebola Zaire, Marburg,
 *     MPXV clade IIb, Nipah). Bundled FASTAs total ~340 kB.
 *
 * Influenza segments (Tier 2) deferred to v0.4 with a dedicated
 * Influenza Virus Resource fetcher; pertussis full genome (4 Mb)
 * also v0.4 with on-demand decompression. Omicron variant Tier 2 =
 * variant-fingerprint catalog (v0.5).
 *
 * v0.5 lights up Tier 3 (annotated derivatives — Nextstrain trees,
 * MSA references, lineage-defining mutation fingerprints).
 * Tier 4 is always external (GISAID adapter; license-aware).
 */

import type { PluginManifest } from '@biomax/types';

import { GENOME_REGISTRY } from './registry.js';
import type { GenomicReference } from './types.js';

export type { GenomicReference } from './types.js';
export { GENOME_REGISTRY } from './registry.js';
export {
  loadBundledGenome, hasBundledGenome, __setBundledGenomes, parseBundledGenome,
  type BundledGenome,
} from './loader.js';

/** Look up a genomic reference by pathogen catalog id. */
export function findGenomicReference(pathogenId: string): GenomicReference | undefined {
  return GENOME_REGISTRY[pathogenId];
}

/** Verify every catalog pathogen has a corresponding genomic reference entry. */
export function listCoveredPathogens(): string[] {
  return Object.keys(GENOME_REGISTRY).sort();
}

export const manifest: PluginManifest = {
  id: 'pathogen-genomics',
  version: '0.1.0',
  engineCompat: '^0.5.0',
  kingdoms: '*',
  systems: [],
  components: [],
};
